import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default-marker icon issue in react-leaflet under bundlers (CRA/webpack)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Auto-fit bounds when salons change
function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 11);
      return;
    }
    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
  }, [points, map]);
  return null;
}

export default function SalonMap({ salons = [] }) {
  const points = salons
    .filter((s) => s.geo_lat && s.geo_lng)
    .map((s) => ({ ...s, lat: s.geo_lat, lng: s.geo_lng }));

  // Sensible default for Germany if no points
  const fallback = { center: [51.1657, 10.4515], zoom: 5 };

  if (points.length === 0) {
    return (
      <div
        className="rounded-2xl border h-64 flex items-center justify-center text-sm"
        style={{ borderColor: "var(--mv-border)", background: "var(--mv-surface)", color: "var(--mv-text-muted)" }}
        data-testid="salon-map-empty"
      >
        Noch keine Salon-Adressen hinterlegt.
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border overflow-hidden"
      style={{ borderColor: "var(--mv-border)", height: 380 }}
      data-testid="salon-map"
    >
      <MapContainer
        center={fallback.center}
        zoom={fallback.zoom}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {points.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]}>
            <Popup>
              <div style={{ minWidth: 180 }}>
                <p style={{ fontWeight: 600, marginBottom: 4 }}>{p.name}</p>
                {p.address && <p style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>{p.address}</p>}
                <p style={{ fontSize: 12 }}>
                  <strong>{(p.stats?.total_revenue || 0).toLocaleString("de-DE", { maximumFractionDigits: 0 })} €</strong> · {p.stats?.total_customers || 0} Kunden · {p.stats?.total_bookings || 0} Termine
                </p>
                <a
                  href={`/salon/${p.slug}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontSize: 11, color: "#C87A5F", textDecoration: "underline", marginTop: 6, display: "inline-block" }}
                >
                  Salon ansehen →
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
